export const DATA_MODEL_HEADER_LABEL_STYLE = {
    fontSize: 12,
    textAlign: "left",
    textBaseline: "middle",
    paddingLeft: 10,
    selectedText: "#ffffff",
    deselectedText: "#000000"
};
